const basePaymentsApiPath = 'organizations/:organizationId/payments';

export const paymentsApiPaths = {
    payment: `${basePaymentsApiPath}/:paymentId`,
    paymentRefund: `${basePaymentsApiPath}/:paymentId/refund`,
    purposeCodes: `${basePaymentsApiPath}/purpose-codes`,
    quotes: `${basePaymentsApiPath}/quotes`,
} as const;
